import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {connect} from 'react-redux';
import RepresentativeLineItem from '../RepresentativeLineItem';
import SearchFieldComponent from '../common/SearchFieldComponent';
import CustomSidePanel from '../common/CustomSidePanel';
import RepresentativeInfoSidePanel from '../RepresentativeInfoSidePanel';
import {
    fetchRepresentatives,
    fetchCustomerRepresentatives,
    saveRepresentative,
    fetchAllRepresentatives, fetchCompanyRepresentatives
} from '../../redux/actions/RepresentativesActions';

const PageWrapper = styled.div`
     display: flex;
     flex-direction: column;
     height: calc(100vh - var(--header-height));;
     width: 100%;
     overflow: hidden;
`;

const PageContent = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-row-gap: 60px;
    
    overflow-y: scroll;
    padding: 40px 44px;
`;

function ProfileRepresentatives(props) {
    const {
        customer,
        representatives,
        fetchAllRepresentatives,
        fetchCustomerRepresentatives,
        fetchCompanyRepresentatives,
        saveRepresentative
    } = props;

    // on mount
    // useEffect(() => {
    //     //fetchCustomerRepresentative()
    //     fetchAllRepresentatives();
    // }, []);
    useEffect(() => {
        // TODO only make call when representative state is empty, else filter through representatives
        fetchCustomerRepresentatives(customer.companyId, customer.id)
    }, [customer]);

    //const representatives = representativesTestData;
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedRep, setSelectedRep] = useState(undefined);

    const handleClose = () => setDrawerOpen(false);

    const onRepresentativeSelected = representative => {
        setDrawerOpen(true);
        setSelectedRep(representative);
    };

    const onSaveRepresentative = representative => {
        saveRepresentative(representative.companyId, representative.customerId, representative.id, representative);
        handleClose();
    };

    return (
        <PageWrapper>
            <PageContent>
                <SearchFieldComponent placeholder="Filter by Name or Email"/>
                {
                    representatives.map((item, index) => (
                        <RepresentativeLineItem
                            key={`representative_${index}`}
                            {...item}
                            // firstName={}
                            // lastName={}
                            // middleName={}
                            // email={}
                            // number={}
                            // status={}
                            // type={}
                            type={(item.primary) ? 'Primary Representative' : 'Alternative Representative'}
                            status={item.isActive}
                            onMoreButtonClick={() => onRepresentativeSelected(item)}
                        />
                    ))
                }
            </PageContent>

            <CustomSidePanel open={drawerOpen} onDrawerClose={handleClose}>
                <RepresentativeInfoSidePanel
                    representativeData={selectedRep}
                    onSave={onSaveRepresentative}
                    onCancel={handleClose}
                />
            </CustomSidePanel>

        </PageWrapper>
    );
}

ProfileRepresentatives.propTypes = {};
ProfileRepresentatives.defaultProps = {};

const mapStateToProps = state => ({representatives: state.representatives});

const mapDispatchToProp = {
    fetchRepresentatives,
    fetchCustomerRepresentatives,
    fetchCompanyRepresentatives,
    fetchAllRepresentatives,
    saveRepresentative,
};

export default connect(mapStateToProps, mapDispatchToProp)(ProfileRepresentatives);
